module.exports = __webpack_public_path__ + "media/images/camo-705e78a2.gif";